import type {
  HumanVerificationConfig,
  HumanVerificationScene,
  ResolvedHumanVerification,
} from '@/types/setting'

/** 全部人机验证场景 */
export const HUMAN_VERIFICATION_SCENES: HumanVerificationScene[] = [
  'send_code',
  'login',
  'generate_element',
  'generate_video',
  'generate_storyboard_image',
  'create_script',
  'script_analysis',
]

/** 各场景默认值：仅 send_code 默认开启 */
export const HUMAN_VERIFICATION_DEFAULTS: ResolvedHumanVerification = {
  send_code: true,
  login: false,
  generate_element: false,
  generate_video: false,
  generate_storyboard_image: false,
  create_script: false,
  script_analysis: false,
}

/** 管理后台展示文案 */
export const HUMAN_VERIFICATION_SCENE_LABELS: Record<HumanVerificationScene, string> = {
  send_code: '获取验证码',
  login: '登录账号',
  generate_element: '生成元素',
  generate_video: '生成视频',
  generate_storyboard_image: '生成分镜图',
  create_script: '创作剧本',
  script_analysis: '剧本分析',
}

/** 合并存储配置与默认值，得到完整场景开关 */
export function resolveHumanVerification(
  saved?: HumanVerificationConfig | null
): ResolvedHumanVerification {
  const resolved = { ...HUMAN_VERIFICATION_DEFAULTS }
  if (!saved) return resolved

  for (const scene of HUMAN_VERIFICATION_SCENES) {
    if (saved[scene] !== undefined) {
      resolved[scene] = saved[scene]!
    }
  }
  return resolved
}
